import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow py-4" }
const _hoisted_2 = { class: "md:flex justify-between items-center px-4 md:px-6 border-b pb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, "Review quotes"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "Review the terms and close the deal")
], -1)
const _hoisted_4 = { class: "flex justify-start md:justify-end items-center mt-4 md:mt-0" }
const _hoisted_5 = { class: "overflow-x-auto py-4 lg:py-6 px-4 md:px-6" }
const _hoisted_6 = { class: "flex items-start" }
const _hoisted_7 = { class: "bg-white rounded-lg shadow py-4 mt-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "md:flex justify-between items-center px-4 md:px-6 border-b pb-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, "Review feedback")
  ])
], -1)
const _hoisted_9 = { class: "overflow-x-auto py-4 lg:py-6 px-4 md:px-6" }
const _hoisted_10 = { class: "flex items-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClipboardCopyIcon = _resolveComponent("ClipboardCopyIcon")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_UserAddIcon = _resolveComponent("UserAddIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SoftQuote = _resolveComponent("SoftQuote")!
  const _component_Feedback = _resolveComponent("Feedback")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "inline-flex md:flex items-center px-3 py-2 bg-gray-100 hover:bg-gray-200 text-sm rounded-md mr-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyQuoteMatrixLink && _ctx.copyQuoteMatrixLink(...args)))
          }, [
            (!_ctx.copied)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ClipboardCopyIcon, { class: "w-4 h-4 mr-1" }),
                  _createTextVNode(" Copy link to matrix ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_CheckCircleIcon, { class: "w-4 h-4 text-green-500 mr-1" }),
                  _createTextVNode(" Copied ")
                ], 64))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "inline-flex md:flex items-center px-3 py-2 bg-green-100 hover:bg-green-500 text-sky hover:text-white text-sm rounded-md mr-2",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showModal('ModalAddQuote')), ["prevent"]))
          }, [
            _createVNode(_component_PlusIcon, { class: "w-4 h-4 mr-1" }),
            _createTextVNode(" Add quote ")
          ]),
          _createVNode(_component_router_link, {
            class: "inline-flex md:flex items-center px-3 py-2 bg-indigo-100 hover:bg-sky text-sky hover:text-white text-sm rounded-md",
            to: { name: 'deal-shortlist' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UserAddIcon, { class: "w-4 h-4 mr-1" }),
              _createTextVNode(" Get more quotes ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quotes, (item) => {
            return (_openBlock(), _createBlock(_component_SoftQuote, {
              key: item.id,
              quote: item.softQuote,
              distribution: item,
              "visibility-control": true,
              class: "max-w-xs flex-shrink-0 mr-4"
            }, null, 8, ["quote", "distribution"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedbacks, (item, index) => {
            return (_openBlock(), _createBlock(_component_Feedback, {
              key: index,
              class: "max-w-xs flex-shrink-0 mr-4",
              feedback: item
            }, null, 8, ["feedback"]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}